import { useCallback } from "react";

import type { CustomAttributeWriteResponse } from "@jti/rest-api-types";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { useMutation, useQueryClient } from "../../../reactQuery";
import { CasCustomAttrsApi } from "../../../services";

type CustomAttributesValues = Record<string, string>;

type UseUpdateCustomAttributesReturn = {
  updateCustomAttributes: (attributes: CustomAttributesValues) => Promise<CustomAttributeWriteResponse | void>;
};

export const useUpdateCustomAttributes = (): UseUpdateCustomAttributesReturn => {
  const casCustomAttrsApi = CasCustomAttrsApi.init();
  const queryClient = useQueryClient();

  const mutation = useMutation((attributes: CustomAttributesValues) => casCustomAttrsApi.write(attributes), {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.profile);
    },
  });

  const updateCustomAttributes = useCallback(
    async (attributes: CustomAttributesValues) => {
      if (!attributes || Object.keys(attributes).length === 0) {
        return Promise.resolve();
      }

      return await mutation.mutateAsync(attributes);
    },
    [mutation]
  );

  return {
    updateCustomAttributes,
  };
};
